import React from "react";

// 클래스 컴포넌트용 자동 폰트-핏
class AutoFitText extends React.PureComponent {
  pRef = React.createRef();
  sRef = React.createRef();
  ro = null;

  componentDidMount() {
    this.fit = this.fit.bind(this);
    this.prepare();
    this.observe();
    this.deferFit();
  }
  componentDidUpdate(prev) {
    if (prev.children !== this.props.children ||
        prev.min !== this.props.min || prev.max !== this.props.max) {
      this.deferFit();
    }
  }
  componentWillUnmount() {
    if (this.ro) this.ro.disconnect();
    window.removeEventListener('resize', this.fit);
  }

  prepare() {
    const p = this.pRef.current;
    if (!p) return;
    p.style.display = 'block';
    p.style.width = '100%';
    p.style.whiteSpace = 'nowrap';
    p.style.overflow = 'hidden';
    p.style.textOverflow = 'ellipsis';
    p.style.lineHeight = this.props.lineHeight ?? '1.12';
  }

  observe() {
    const p = this.pRef.current;
    if (!p) return;

    if (typeof ResizeObserver !== 'undefined') {
      this.ro = new ResizeObserver(this.fit);
      this.ro.observe(p);
      if (p.parentElement) {
        this.ro.observe(p.parentElement);
      }
    }
    window.addEventListener('resize', this.fit);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.fit).catch(() => {});
    }
  }

  deferFit() {
    requestAnimationFrame(() => requestAnimationFrame(this.fit));
  }

  fit() {
    const p = this.pRef.current;
    const s = this.sRef.current;
    if (!p || !s) return;

    const min = Math.max(1, Math.floor(this.props.min ?? 12));
    const max = Math.max(min, Math.floor(this.props.max ?? 16));

    const avail = p.clientWidth || (p.parentElement ? p.parentElement.clientWidth : 0);
    if (!avail) return;

    let lo = min, hi = max, best = min;
    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      p.style.fontSize = `${mid}px`;

      const textWidth = Math.ceil(s.offsetWidth);
      const overflow = textWidth > Math.floor(p.clientWidth);

      if (!overflow) { best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    p.style.fontSize = `${best}px`;
  }

  render() {
    const { className, children, title } = this.props;
    return (
      <p
        ref={this.pRef}
        className={className}
        title={title ?? (typeof children === 'string' ? children : undefined)}
      >
        <span ref={this.sRef}>{children}</span>
      </p>
    );
  }
}

export default AutoFitText;